<template>
  <div id="app">
    <v-app>
      <!-- ================================toolbar==================   -->
    <div>
        <v-app-bar color="white"
        elevate-on-scroll
        app
        scroll-target="#scrolling-techniques-7"
        >
            <v-app-bar-nav-icon
                @click.stop="drawer = !drawer"
                v-if="$vuetify.breakpoint.smAndDown"
            >
            </v-app-bar-nav-icon>
            <div class="container">
                <v-toolbar dense flat class="transparent indigo--text text--darken-4 px-0 mx-0">
                    <a href="#beranda">
                        <img height="40px" class="logo-act-m" src="https://cdn.siap.id/s3/siap_belajar/portal/img/logo.png"/>
                    </a>
                    <v-spacer></v-spacer>

                    <div v-if="$vuetify.breakpoint.mdAndUp" class="">
                        <v-btn href="#beranda" class="text-capitalize purple--text text--darken-4" text>Beranda</v-btn>
                        <v-btn href="#keunggulan" class="text-capitalize purple--text text--darken-4" text>Keunggulan</v-btn>
                        <!-- <v-btn href="#konten" class="text-capitalize purple--text" text>Konten</v-btn> -->
                        <v-btn href="#fitur" class="text-capitalize purple--text text--darken-4" text>Fitur</v-btn>
                        <v-btn href="#course" class="text-capitalize purple--text text--darken-4" text>Course</v-btn>
                        <v-btn href="#kontak" class="text-capitalize purple--text text--darken-4" text>Kontak</v-btn>
                        <!-- <v-btn @click="aktivasiInstansi" class="text-capitalize purple--text text--darken-4" text>Aktivasi Instansi</v-btn> -->
                        <v-btn @click="toSIM()"
                        class="elevation-11 rounded-pill text-capitalize indigo--text text--darken-4 amber darken-1">
                        Masuk 
                        </v-btn>
                        <!-- <v-menu bottom offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn href="" v-bind="attrs" v-on="on"
                                class="elevation-11 rounded-pill text-capitalize indigo--text text--darken-4 amber darken-1">
                                Aktivasi <v-icon class="mdi mdi-chevron-down"></v-icon>
                            </v-btn>
                        </template>
                            <v-list>
                                <v-list-item @click="aktivasiInstansi">
                                    <v-list-item-title class=" purple--text text--darken-4">Aktivasi Instansi</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="aktivasiSiswa">
                                    <v-list-item-title class=" purple--text text--darken-4">Aktivasi Siswa</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu> -->

                        <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn href="https://bantuan-belajar.siap.id/"
                            v-bind="attrs"
                            v-on="on" class="text-capitalize purple--text" text>
                            <v-icon class="purple--text text--lighten-2 mdi mdi-help-circle-outline"></v-icon>
                        </v-btn>
                        </template>
                        <span>Bantuan</span>
                        </v-tooltip> -->

                    </div>

                    <v-menu
                    left
                    bottom
                    :rounded="rounded"
                    >

                    <v-list>
                        <v-list-item
                        v-for="n in 5"
                        :key="n"
                        @click="() => {}"
                        >
                        <v-list-item-title>Option {{ n }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    </v-menu>
                </v-toolbar>

            </div>
        </v-app-bar>
   </div>
   <!-- =======================sidebar===================== -->
    <MSideBar :drawer="drawer" />

    <!-- =================sc1=============================== -->
     <!-- <v-alert
      icon="mdi-info"
      prominent
      text
      type="info"
    >
      <b>Siap Belajar PPDB Jawa Tengah</b>. <br/>Saat ini sedang dilakukan proses <b>evaluasi data</b>, masa input data akan dibuka kembali pada tanggal <b>24 Mei 2021</b>. Aktivasi token/akun sekolah (yang belum) mulai tanggal <b>18 Mei 2021</b>
    </v-alert> -->
    <section class="hero py-5" id="beranda">
        <div class="container">
            <v-row class="" style="margin-top:3%; margin-bottom:2% ;">
                <v-col cols="12" md="6" sm="6">
                    <div class="mb-5 mr-3 tx-hero text-deep-purple">
                            <span class="indigo--text text--darken-4" style="font-size: 33pt;">Belajar Online Bersama <b>SIAP Belajar</b></span>
                        </div>
                        <div class="mb-5" style="line-height: 33px;">
                            <p>SIAP Belajar adalah sebuah layanan berbasiskan SIAP Platform yang terintegrasi
                                untuk menunjang proses pembelajaran jarak jauh <i>(elearning)</i> bagi Guru dapat memberikan
                                materi, tugas serta class dan siswa dapat mengikuti pembelajaran seperti mengerjakan
                                tugas, kuis dan mendapatkan materi pembelajaran.
                                <br>
                                Sudahkah Anda SIAP belajar?</p>
                        </div>

                        <!-- -----------btn------------ -->
                         <v-btn
                              @click="aktivasiInstansi"
                              class="purple darken-4 large white--text mr-3 flat">
                              Aktivasi Instansi
                            </v-btn>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                    <div class="mt-md-5 pa-0 ma-0">
                        <img fluid src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-13.png" style="width: 100%">
                    </div>
                </v-col>

            </v-row>
        </div>
    </section>

   <!-- -------------sc2------------------------  -->
    <section id="keunggulan" class="pt-7 mt-10 bg-keunggulan">
        <div class="container pa-5">
            <v-row v-if="$vuetify.breakpoint.mdAndUp">
                <v-col cols="12" md="12" sm="12" class="text-center mt-5 mb-5">
                        <p class="font-weight-bold">Keunggulan</p>
                        <p class="indigo--text text--darken-4" style="font-size: 25pt;">Nikmati Keunggulan <b>SIAP Belajar</b></p>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                        <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-19.png" height="90px" alt="">
                        <p class="indigo--text text--darken-4 font-weight-bold"><i>Central Authentication Service</i></p>
                        <p >Memudahkan pengguna untuk bisa mengakases berbagai produk
                             yang ada di dalam<i> Platform</i> SIAP hanya dengan satu akun.</p>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-16.png" height="90px" alt="">
                    <p class="indigo--text text--darken-4 font-weight-bold">Berbasis SaaS dan<i> Cloud Computing</i></p>
                    <p class="">Penggunaan mudah, cepat, tanpa instalasi dan<i>
                        maintenance server</i>. Akses bagi semua Guru, Siswa dan Orang Tua.
                    </p>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-17.png" height="90px" alt="">
                    <p class="indigo--text text--darken-4 font-weight-bold">Tata Kelola Manajemen Pengguna</p>
                    <p class="">Sistem Informasi Manajemen mempermudah tata kelola penjadwalan,
                        tata kelola peserta, dan tata kelola kesiapan kelas yang lain.</p>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-15.png" height="90px" alt="">
                    <p class="indigo--text text--darken-4 font-weight-bold"><i> Learning Management System</i></p>
                    <p class="">Dengan fasilitas LMS berbasiskan<i> mobile platform</i>
                         dapatkan kemudahan untuk merancang modul pembelajaran sendiri.</p>
            </v-col>
            <v-col cols="12" md="4" sm="6">
                <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-14.png" height="90px" alt="">
                <p class="indigo--text text--darken-4 font-weight-bold">Instruksional Desain Pembelajaran</p>
                <p class="">Memberikan keleluasaan pengaturan desain modul pembelajaran sesuai dengan
                    pola masing - masing guru.
                </p>
            </v-col>
            <v-col cols="12" md="4" sm="6">
                <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-18.png" height="90px" alt="">
                <p class="indigo--text text--darken-4 font-weight-bold">Apps SIAP Belajar</p>
                <p class="">Tidak hanya dapat diakses menggunakan laptop atau komputer, SIAP Belajar menyediakan Apps Android
                    Platform yang dapat dinikmati oleh semua pengguna.
                </p>
            </v-col>
            </v-row>

            <v-row v-if="$vuetify.breakpoint.smAndDown" class="text-center">
                <v-col cols="12" md="12" sm="12" class="text-center mt-5 mb-5">
                        <p class="font-weight-bold">Keunggulan</p>
                        <p class="indigo--text text--darken-4" style="font-size: 25pt;">Nikmati Keunggulan <b>SIAP Belajar</b></p>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                        <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-19.png" height="90px" alt="">
                        <p class="indigo--text text--darken-4 font-weight-bold"><i>Central Authentication Service</i></p>
                        <p class="">Memudahkan pengguna untuk bisa mengakases berbagai produk
                             yang ada di dalam<i> Platform</i> SIAP hanya dengan satu akun.</p>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-16.png" height="90px" alt="">
                    <p class="indigo--text text--darken-4 font-weight-bold">Berbasis SaaS dan<i> Cloud Computing</i></p>
                    <p class="">Penggunaan mudah, cepat, tanpa instalasi dan<i>
                        maintenance server</i>. Akses bagi semua Guru, Siswa dan Orang Tua.
                    </p>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-17.png" height="90px" alt="">
                    <p class="indigo--text text--darken-4 font-weight-bold">Tata Kelola Manajemen Pengguna</p>
                    <p class="">Sistem Informasi Manajemen mempermudah tata kelola penjadwalan,
                        tata kelola peserta, dan tata kelola kesiapan kelas yang lain.</p>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-15.png" height="90px" alt="">
                    <p class="indigo--text text--darken-4 font-weight-bold"><i> Learning Management System</i></p>
                    <p class="">Dengan fasilitas LMS berbasiskan<i> mobile platform</i>
                         dapatkan kemudahan untuk merancang modul pembelajaran sendiri.</p>
            </v-col>
            <v-col cols="12" md="4" sm="6">
                <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-14.png" height="90px" alt="">
                <p class="indigo--text text--darken-4 font-weight-bold">Instruksional Desain Pembelajaran</p>
                <p class="">Memberikan keleluasaan pengaturan desain modul pembelajaran sesuai dengan
                    pola masing - masing guru.
                </p>
            </v-col>
            <v-col cols="12" md="4" sm="6">
                <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-18.png" height="90px" alt="">
                <p class="indigo--text text--darken-4 font-weight-bold">Apps SIAP Belajar</p>
                <p class="">
Tidak hanya dapat diakses menggunakan laptop atau komputer, SIAP Belajar menyediakan Apps Android Platform yang dapat dinikmati oleh semua pengguna

                </p>
            </v-col>
            </v-row>
        </div>
    </section>

    <!-- <section id="konten" class="pt-10 mt-10 bg-konten">
        <div class="container pa-5">
            <v-row>
                <v-col cols="12" md="12" class="text-center mt-5 mb-5">
                        <p class="grey--text font-weight-bold">Konten</p>
                        <p class="indigo--text text--darken-4" style="font-size: 25pt;">Bank Soal dan<br> Konten <b>SIAP Belajar</b></p>
                </v-col>
                <v-col cols="12" md="4">
                        <v-card class="py-5 px-3" height="600px" style=" webkit-box-shadow: 0px 0px 12px 15px rgba(0, 0, 0, 0.082);">
                            <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-03.png" width="100%">
                                <div class="text-center">
                                    <p class="indigo--text text--darken-4" style="font-size: 25pt;">Konten <b>Pembelajaran</b></p>
                                    <div class="txt-grey">
                                        <p class="my-4 grey--text" style="line-height: 30px;">Media untuk penyimpanan konten-konten pembelajaran dalam
                                            bentuk dokumen, presentasi dan <i>portable document format</i></p>
                                    </div>
                                </div>
                        </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="py-5 px-3" height="600px" style=" webkit-box-shadow: 0px 0px 12px 15px rgba(0, 0, 0, 0.082);">
                        <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-02.png" width="100%">
                            <div class="text-center">
                                <p class="indigo--text text--darken-4" style="font-size: 25pt;">Butir Butir<br><b> Soal</b></p>
                                <div class="txt-grey">
                                    <p class="my-4 grey--text" style="line-height: 30px;">Bisa membuat soal dengan rumus matematika dan melihat
                                        butir-butir soal koleksi pengajar yang lainnya</p>
                                </div>
                            </div>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="py-5 px-3" height="600px" style=" webkit-box-shadow: 0px 0px 12px 15px rgba(0, 0, 0, 0.082);">
                        <img src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-04.png" width="100%">
                            <div class="text-center">
                                <p class="indigo--text text--darken-4" style="font-size: 25pt;">Kelompok<br> <b>Soal</b></p>
                                <div class="txt-grey">
                                    <p class="my-4 grey--text" style="line-height: 30px;">Kelompok-kelompok soal berdasarkan jenjang sekolah dan tingkat.
                                        Dapat dikategorikan sesuai tingkat kesulitan soal</p>
                                </div>
                            </div>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </section> -->

<!-- -------------sc3-------------------- -->
    <section id="fitur" class="pt-10 mt-10 bg-fitur1">
        <div class="container mt-5">
            <v-row>
                <v-col cols="12" md="6" sm="6" class="d-flex align-center">
                    <img width="100%" src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-11.png" alt="">
                </v-col>
                <v-col cols="12" md="6" sm="6" class="d-flex align-center">
                    <div class="mx-5 mt-10 pa-5">
                        <p class="font-weight-bold">Fitur</p>
                        <p  class="indigo--text text--darken-4" style="font-size: 20pt;"><b>SIM</b><br> (Sistem Informasi Manajemen)</p>
                        <div class="mb-5">
                            <p>
                                <ul class="" style="line-height: 30px;">
                                    <li>Integrasi SSO LMS Diklat
                                      </li>
                                      <li>Tata Kelola Kelompok Diklat Mata Pelajaran</li>
                                      <li>Tata Kelola Diklat dan Kelas</li>
                                      <li>Tata Kelola Peserta Kelas</li>
                                      <li>Tata Kelola Rombongan Belajar</li>
                                      <li>Tata Kelola <i>Course</i> Mulai-Selesai</li>
                                      <li>Instruksional<i> Design</i> Pembelajaran LMS Diklat</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </section>
    <section id="fitur" class="pt-5 bg-fitur2">
        <div class="container">
            <v-row class="">
                <v-col cols="12" md="6" sm="6" class="d-flex align-center">
                    <div class="ma-5 pa-5">
                        <p class="font-weight-bold">Fitur</p>
                        <p  class="indigo--text text--darken-4" style="font-size: 20pt;"><b>LMS</b> <br><i>(Learning Management System)</i></p>
                        <div class="mb-5">
                            <p>
                                <ul>
                                  <li><i>
                                    Virtual Class</i>
                                    </li>
                                    <li>
                                      Integrasi SSO SIM Diklat</li>
                                    <li>
                                      RPP - Rencana Pelaksanaan Pembelajaran</li>
                                    <li>
                                      Mekanisme <i> Management System (Learndash Plaform)</i></li>
                                      <li>
                                        Kuis dan Ujian Online</li>
                                      <li>
                                        Tugas dan Materi Pembelajaran</li>
                                    </ul>
                            </p>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" md="6" sm="6"  class="d-flex align-center">
                    <img width="100%" src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-10.png" alt="">
                </v-col>
            </v-row>
        </div>
    </section>
    <section id="fitur" class="pt-5 bg-fitur3">
        <div class="container">
            <v-row>
                <v-col cols="12" md="6" sm="6"  class="d-flex align-center">
                    <img width="100%" src="https://cdn.siap.id/s3/siap_belajar/portal/img/aset-09.png" alt="">
                </v-col>
                <v-col cols="12" md="6" sm="6" class="d-flex align-center">
                    <div class="ma-5 pa-5">
                        <p class=" font-weight-bold">Fitur</p>
                        <p  class="indigo--text text--darken-4" style="font-size: 20pt;"><b>Apps</b> (Layanan Sistem <i>Mobile Apps</i>)</p>
                        <div class="mb-5  ">
                            <p>
                                <ul>
                                  <li>Integrasi SSO LMS Diklat
                                    </li>
                                  <li>Akses course/kelas yang diikuti</li>
                                  <li>Mengerjakan modul dan materi</li>
                                  <li>Monitoring prosentase aktivitas course/kelas</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </section>



    <section id="course" class="pt-10 mt-10 bg-keunggulan">
        <div class="container">
            <v-row>
                <v-col cols="12" md="12" class="text-center mt-5 mb-5">
                        <p class=" font-weight-bold">Course</p>
                        <p class="indigo--text text--darken-4" style="font-size: 25pt;">Pilihan Course<br> <b>Terbaru</b> untuk Anda</p>
                </v-col>
                 <v-col cols="12" md="12" class="text-center mt-5 mb-5">
                        <img height="250px" src="https://cdn.siap.id/s3/asset%20illustrasi/Illustrasi/aset_halaman-kosong.png"/>
                </v-col>
                <!-- <v-col cols="12" md="4">
                        <v-card class="py-5 px-5 rounded-lg" height="480px" style=" webkit-box-shadow: 0px 0px 12px 15px rgba(0, 0, 0, 0.082);">
                            <span class="amber caption font-weight-bold darken-1 px-3 rounded"
                            style="position: absolute; top: 35px; left: 35px;">  Free
                            </span>
                            <img class="rounded-lg" src="https://dxs-ui.dev.siap.id/ui-ux-maba/devi/portal/siapbelajar-vue/img/courses.jpg" width="100%">
                            <div class="my-2">
                                <small class="blue--text">
                                    <i class="mdi mdi-cards-heart mr-2" ></i>4 Menyukai
                                </small>
                            </div>
                            <div class="card-body px-0 py-0 mb-5">
                                <p style="font-size: 17pt;">Konsep Dasar Multimedia Pembelajaran</p>
                                <span class="red white--text px-3 py-1 rounded caption">Multimedia</span>
                            </div>
                            <div class="" style="color: grey; margin-top: auto;">
                                <v-divider></v-divider>
                                <div style="position: absolute; bottom: 20px;">
                                    <span class="my-0 mr-2"><i class="mdi mdi-book"></i> <small>9 Lesson</small> </span>
                                    <span class="my-0"><i class="mdi mdi-clock"></i> <small>8h 12m</small> </span>
                                </div>
                            </div>
                            <button class="rounded-circle border-0"
                            style="width: 40px; height: 40px; background:#A458C1; position: absolute; bottom: 15px; right: 30px;">
                                <i class="mdi mdi-arrow-right" style="color: white;"></i>
                            </button>
                        </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="py-5 px-5 rounded-lg" height="480px" style=" webkit-box-shadow: 0px 0px 12px 15px rgba(0, 0, 0, 0.082);">
                        <span class="amber caption font-weight-bold darken-1 px-3 rounded"
                        style="position: absolute; top: 35px; left: 35px;">  Free
                        </span>
                        <img class="rounded-lg" src="https://dxs-ui.dev.siap.id/ui-ux-maba/devi/portal/siapbelajar-vue/img/courses.jpg" width="100%">
                        <div class="my-2">
                            <small class="blue--text">
                                <i class="mdi mdi-cards-heart mr-2" ></i>4 Menyukai
                            </small>
                        </div>
                        <div class="card-body px-0 py-0 mb-5">
                            <p style="font-size: 17pt;">Mengenali Arti Arti atau Filosofi Warna</p>
                            <span class="red white--text px-3 py-1 rounded caption">Multimedia</span>
                        </div>
                        <div class="" style="color: grey; margin-top: auto;">
                            <v-divider></v-divider>
                            <div style="position: absolute; bottom: 20px;">
                                <span class="my-0 mr-2"><i class="mdi mdi-book"></i> <small>9 Lesson</small> </span>
                                <span class="my-0"><i class="mdi mdi-clock"></i> <small>8h 12m</small> </span>
                            </div>
                        </div>
                        <button class="rounded-circle border-0"
                        style="width: 40px; height: 40px; background:#A458C1; position: absolute; bottom: 15px; right: 30px;">
                            <i class="mdi mdi-arrow-right" style="color: white;"></i>
                        </button>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                        <v-card class="py-5 px-5 rounded-lg" height="480px" style=" webkit-box-shadow: 0px 0px 12px 15px rgba(0, 0, 0, 0.082);">
                            <span class="amber darken-1 caption font-weight-bold px-3 rounded"
                            style="position: absolute; top: 35px; left: 35px;">  Free
                            </span>
                            <img class="rounded-lg" src="https://dxs-ui.dev.siap.id/ui-ux-maba/devi/portal/siapbelajar-vue/img/courses.jpg" width="100%">
                            <div class="my-2">
                                <small class="blue--text">
                                    <i class="mdi mdi-cards-heart mr-2" ></i>4 Menyukai
                                </small>
                            </div>
                            <div class="card-body px-0 py-0 mb-5">
                                <p style="font-size: 17pt;">Mengenal Teknologi Pengenalan Wajah (Facial Recognition)</p>
                                <span class="red white--text px-3 py-1 rounded caption">Multimedia</span>
                            </div>
                            <div class="" style="color: grey; margin-top: auto;">
                                <v-divider></v-divider>
                                <div style="position: absolute; bottom: 20px;">
                                    <span class="my-0 mr-2"><i class="mdi mdi-book"></i> <small>9 Lesson</small> </span>
                                    <span class="my-0"><i class="mdi mdi-clock"></i> <small>8h 12m</small> </span>
                                </div>
                            </div>
                            <button class="rounded-circle border-0"
                            style="width: 40px; height: 40px; background:#A458C1; position: absolute; bottom: 15px; right: 30px;">
                                <i class="mdi mdi-arrow-right" style="color: white;"></i>
                            </button>
                        </v-card>
                </v-col> -->
            </v-row>
        </div>
    </section>

    <section id="" class="pt-10 mt-10 bg-fitur1">
        <div class="container">
            <v-row>
                <v-col cols="12" md="12" class="text-center mt-5 mb-5">
                        <p class=" font-weight-bold">Course</p>
                        <p class="indigo--text text--darken-4" style="font-size: 25pt;">Pilihan Course<br> <b>Terbaik</b> untuk Anda</p>
                </v-col>
                <v-col cols="12" md="12" class="text-center mt-5 mb-5">
                        <img height="250px" src="https://cdn.siap.id/s3/asset%20illustrasi/Illustrasi/aset_halaman-kosong.png"/>
                </v-col>
            </v-row>
        </div>
    </section>

    <!-- <section id="" class="pt-10 mt-10 bg-fitur3">
        <div class="container">
            <v-row>
                <v-col cols="12" md="12" class="text-center mt-5 mb-5">
                        <p class="grey--text font-weight-bold">Sekolah</p>
                        <p class="indigo--text text--darken-4" style="font-size: 25pt;">Telah Bergabung<br>Bersama <b>Siap Belajar</b></p>
                </v-col>
                <v-col cols="12" md="6">
                                <p class="indigo--text text--darken-4 font-weight-bold" style="font-size: 13pt;">
                                    Sekolah Teraktif
                                </p>
                                <v-card class="my-3 px-5 py-3" style=" webkit-box-shadow: 0px 5px 8px 2px rgba(0, 0, 0, 0.075);">
                                    <v-row>
                                        <v-col cols="12" md="2" class="pt-5">
                                            <span class="blue rounded-lg white--text pa-5"
                                            >
                                            <v-icon class="white--text">mdi mdi-pencil</v-icon>
                                            </span>
                                        </v-col>
                                        <v-col cols="12" md="10">
                                            <b class="ml-3">SMPN 4 Pakem</b>
                                            <p class="ml-3 mb-0 caption grey--text" style="font-size: small;">Jl. (Alamat SMPN 4)</p>
                                        </v-col>
                                    </v-row>

                                </v-card>
                                <v-card class="my-3 px-5 py-3" style=" webkit-box-shadow: 0px 5px 8px 2px rgba(0, 0, 0, 0.075);">
                                    <v-row>
                                        <v-col cols="12" md="2" class="pt-5">
                                            <span class="blue rounded-lg white--text pa-5"
                                            >
                                            <v-icon class="white--text">mdi mdi-pencil</v-icon>
                                            </span>
                                        </v-col>
                                        <v-col cols="12" md="10">
                                            <b class="ml-3">SMPN 4 Pakem</b>
                                            <p class="ml-3 mb-0 caption grey--text" style="font-size: small;">Jl. (Alamat SMPN 4)</p>
                                        </v-col>
                                    </v-row>

                                </v-card>
                                <v-card class="my-3 px-5 py-3" style=" webkit-box-shadow: 0px 5px 8px 2px rgba(0, 0, 0, 0.075);">
                                    <v-row>
                                        <v-col cols="12" md="2" class="pt-5">
                                            <span class="blue rounded-lg white--text pa-5"
                                            >
                                            <v-icon class="white--text">mdi mdi-pencil</v-icon>
                                            </span>
                                        </v-col>
                                        <v-col cols="12" md="10">
                                            <b class="ml-3">SMPN 4 Pakem</b>
                                            <p class="ml-3 mb-0 caption grey--text" style="font-size: small;">Jl. (Alamat SMPN 4)</p>
                                        </v-col>
                                    </v-row>

                                </v-card>

                </v-col>
                <v-col cols="12" md="6">
                    <p class="indigo--text text--darken-4 font-weight-bold" style="font-size: 13pt;">
                        Sekolah Terbaru
                    </p>
                    <v-card class="my-3 px-5 py-3" style=" webkit-box-shadow: 0px 5px 8px 2px rgba(0, 0, 0, 0.075);">
                        <v-row>
                            <v-col cols="12" md="2" class="pt-5">
                                <span class="blue rounded-lg pa-5"
                                >
                                <v-icon class="white--text">mdi mdi-clock-check-outline</v-icon>
                                </span>
                            </v-col>
                            <v-col cols="12" md="10">
                                <b class="ml-3">SMPN 4 Pakem</b>
                                <p class="ml-3 mb-0 caption grey--text" style="font-size: small;">Jl. (Alamat SMPN 4)</p>
                            </v-col>
                        </v-row>

                    </v-card>
                <v-card class="my-3 px-5 py-3" style=" webkit-box-shadow: 0px 5px 8px 2px rgba(0, 0, 0, 0.075);">
                    <v-row>
                        <v-col cols="12" md="2" class="pt-5">
                            <span class="blue rounded-lg white--text pa-5"
                            >
                            <v-icon class="white--text">mdi mdi-clock-check-outline</v-icon>
                            </span>
                        </v-col>
                        <v-col cols="12" md="10">
                            <b class="ml-3">SMPN 4 Pakem</b>
                            <p class="ml-3 mb-0 caption grey--text" style="font-size: small;">Jl. (Alamat SMPN 4)</p>
                        </v-col>
                    </v-row>

                </v-card>
                <v-card class="my-3 px-5 py-3" style=" webkit-box-shadow: 0px 5px 8px 2px rgba(0, 0, 0, 0.075);">
                    <v-row>
                        <v-col cols="12" md="2" class="pt-5">
                            <span class="blue rounded-lg white--text pa-5"
                            >
                            <v-icon class="white--text">mdi mdi-clock-check-outline</v-icon>
                            </span>
                        </v-col>
                        <v-col cols="12" md="10">
                            <b class="ml-3">SMPN 4 Pakem</b>
                            <p class="ml-3 mb-0 caption grey--text" style="font-size: small;">Jl. (Alamat SMPN 4)</p>
                        </v-col>
                    </v-row>

                </v-card>

                </v-col>
            </v-row>
        </div>
    </section> -->

<!-- ----------banner iklan------------ -->
    <!-- <section id="iklan" style="margin-top: 100px;margin-bottom: 100px;">
        <div class="container">
            <a href="https://paspor.siap-online.com/cas/login?service=https://api-belajar.siap.id" target="_blank">
                <img class="ml-auto mr-auto d-none d-md-flex d-lg-flex d-xl-flex d-lg-none" src="https://cdn.siap.id/s3/siap_belajar/portal/img/banner.png?1">
                <img class="d-xl-none d-lg-none p-2 d-md-none" src="https://cdn.siap.id/s3/siap_belajar/portal/img/banner-m.png?2">
            </a>
        </div>
    </section> -->
    
    <div id="aktivasiinstansi"></div>
    <div id="aktivasisiswa"></div>


    <footer class="bg-footer" style="padding-top:150px ;" id="kontak">
        <div class="container">
            <v-row class=" white--text">
                <v-col cols="12" md="3" lg="3"></v-col>
                <v-col cols="12" md="6" lg="6" sm="12" class=" text-center my-5 py-5">
                    <img height="90px" style="margin-top: 200px;" class="mt-5"
                    src="https://cdn.siap.id/s3/siap_belajar/portal/img/logo-putih.png">
                    <v-row style="margin-bottom:80px">
                        <v-col cols="12" md="6" sm="6"
                                class="pa-5">
                            <a href="mailto:belajar@siap-online.com" target="_blank">
                             <v-btn
                                outlined width="100%"
                                color="white"
                                >
                                <v-icon class="mr-1">mdi mdi-email-outline</v-icon>Email Kami
                                </v-btn>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" sm="6"
                                class="pa-5">
                            <a href="https://bantuan-belajar.siap.id/" target="_blank">
                             <v-btn
                                outlined width="100%"
                                color="white"
                                >
                                <v-icon class="mr-1">mdi mdi-help-circle-outline</v-icon>Situs Bantuan
                                </v-btn>
                            </a>
                        </v-col>
                    </v-row>
                </v-col>


                <v-col cols="12" md="12">
                    <v-divider color="white"></v-divider>
                    <v-row class=" pt-3 text-center">
                        <v-col cols="12" md="3"></v-col>
                        <v-col cols="12" md="6">
                            <div class="mb-3  caption">Copyright © 2020, SIAP Belajar</div>
                        </v-col>
                        <v-col cols="12" md="3"></v-col>
                    </v-row>

                </v-col>
            </v-row>
        </div>
    </footer>


    </v-app>
  </div>
</template>
<script>
import { SIM } from "@/const";
import MSideBar from "@/components/SidebarMobile";
export default {
    components: {
    MSideBar,
  },
    data() {
        return {
            dialog: false,
            drawer: true,
            items: [],
            rounded: true,
        }
    },
    methods:{
        toSIM(){
           window.open(SIM, "_blank");
        },
        aktivasiInstansi(){
           window.open(SIM+'#/aktivasi-instansi', "_blank");
        },
        aktivasiSiswa(){
           window.open(SIM+'#/aktivasi-akun', "_blank");

        }
    }
}
</script>

 <style>
        .container{
            max-width: 1020px;
        }
        .hero{
            background: url("https://cdn.siap.id/s3/siap_belajar/portal/img/aset-01.png") no-repeat;
            background-size: cover;
        }
        .bg-footer {
    background: url("https://cdn.siap.id/s3/siap_belajar/portal/img/aset-12a.png") no-repeat;
    background-size: cover;
    padding-top: 50px
}
.bg-keunggulan {
    background: url("https://cdn.siap.id/s3/siap_belajar/portal/img/aset-08.png") no-repeat;
    background-size: cover;
    padding-top: 50px
}
.bg-konten {
    background: url("https://cdn.siap.id/s3/siap_belajar/portal/img/aset-05.png") no-repeat;
    background-size: cover;
    padding-top: 50px
}
.bg-fitur1 {
    background: url("https://cdn.siap.id/s3/siap_belajar/portal/img/aset-06.png") no-repeat;
    background-size: cover;
    padding-top: 50px
}
.bg-fitur2 {
    background: url("https://cdn.siap.id/s3/siap_belajar/portal/img/aset-07.png") no-repeat;
    background-size: cover;
    padding-top: 50px
}
.bg-fitur3 {
    background: url("https://cdn.siap.id/s3/siap_belajar/portal/img/aset-05.png") no-repeat;
    background-size: cover;
    padding-top: 50px
}
    </style>
